// Renders app-specific widgets declared by canonical content.

import React from 'react';
import type { Document, Widget } from '@airhead-games/shared/content';
import ShareActions from '@/content/rendering/chrome/ShareActions';
import WidgetClipRail from '@/content/rendering/renderers/widgets/WidgetClipRail';
import WidgetDocumentList from '@/content/rendering/renderers/widgets/WidgetDocumentList';
import WidgetEmptyState from '@/content/rendering/renderers/widgets/WidgetEmptyState';
import WidgetLinkCardGrid from '@/content/rendering/renderers/widgets/WidgetLinkCardGrid';
import WidgetRelatedDocuments from '@/content/rendering/renderers/widgets/WidgetRelatedDocuments';
import WidgetSongTable from '@/content/rendering/renderers/widgets/WidgetSongTable';

interface WidgetRendererProps {
  widgets?: Widget[];
  currentDocument?: Document;
}

const WidgetRenderer: React.FC<WidgetRendererProps> = ({
  widgets,
  currentDocument,
}) => {
  if (!widgets?.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6">
      {widgets.map((widget, index) => {
        if (widget.type === 'documentList') {
          return <WidgetDocumentList key={index} widget={widget} />;
        }
        if (widget.type === 'relatedDocuments') {
          return (
            <WidgetRelatedDocuments
              key={index}
              widget={widget}
              currentDocument={currentDocument}
            />
          );
        }
        if (widget.type === 'clipScroller') {
          return <WidgetClipRail key={index} widget={widget} />;
        }
        if (widget.type === 'songTable') {
          return <WidgetSongTable key={index} widget={widget} />;
        }
        if (widget.type === 'emptyState') {
          return <WidgetEmptyState key={index} widget={widget} />;
        }
        if (widget.type === 'linkCardGrid') {
          return <WidgetLinkCardGrid key={index} widget={widget} />;
        }
        if (widget.type === 'shareActions' && currentDocument) {
          return <ShareActions key={index} document={currentDocument} />;
        }
        return null;
      })}
    </div>
  );
};

export default WidgetRenderer;
